export const defaultErrorMsg = (errorCode = 400) =>
  `Oops! Something went wrong. Please contact your account manager for support. (Error code: ${errorCode})`;
